module.exports = __webpack_public_path__ + "img/kvikkleire.5a46c07f.jpg";